import { useEffect, useState } from 'react'
import { roleService } from '@/services/RoleService'
import type { RoleDto } from '@/helpers/api/WebApiClient'

/**
 * tenantId: SuperAdmin-only — load another org's roles instead of the caller's own (see
 * IRoleRepository). Omit for the normal own-tenant flow.
 */
export function useRoles(reloadTrigger?: boolean, tenantId?: number) {
	const [roles, setRoles] = useState<RoleDto[]>([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<Error | null>(null)

	const fetchRoles = async () => {
		setLoading(true)
		setError(null)
		try {
			const response = await roleService.getList(tenantId)
			setRoles(response)
		} catch (err) {
			setError(err instanceof Error ? err : new Error('Failed to fetch roles'))
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchRoles()
	}, [reloadTrigger, tenantId])

	return { roles, loading, error, refetch: fetchRoles }
}
